<template>
  <div>
    <div style="margin-bottom: 20px">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item> 补货记录 </el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <el-card shadow="hover" style="margin-bottom: 12px; padding: 10px">
      <el-form :inline="true" :model="formInline" @submit.native.prevent>
        <el-form-item label="门店仓库">
          <customer-store-select
            :defaultFirst="true"
            style="width: 180px"
            v-model="storeGuid"
            placeholder="门店"
          />
        </el-form-item>
        <el-form-item label="所属门店">
          <el-button-group>
            <el-button
              @click="onActiveClick('replenish_storehouse')"
              :type="activeName == 'replenish_storehouse' ? 'primary' : 'default'"
            >
              下级门店
            </el-button>
            <el-button
              @click="onActiveClick('replenish')"
              :type="activeName == 'replenish' ? 'primary' : 'default'"
            >
              当前门店
            </el-button>
          </el-button-group>
        </el-form-item>
        <el-form-item label="记录状态">
          <el-select
            v-model="formInline.optStatus"
            @change="queryClick"
            style="width: 140px"
            placeholder="记录状态"
          >
            <el-option label="全部状态" value=""></el-option>
            <el-option label="待确认的" value="0"></el-option>
            <el-option label="待出库的" value="1"></el-option>
            <el-option label="待采购的" value="11"></el-option>
            <el-option label="等待入库" value="2"></el-option>
            <el-option label="已完成的" value="3"></el-option>
            <el-option label="已关闭的" value="4"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="搜索内容">
          <el-input
            v-model="formInline.queryValue"
            @change="queryClick"
            placeholder="关键词"
          ></el-input>
        </el-form-item>
      </el-form>
    </el-card>
    <el-card shadow="hover">
      <div style="padding: 10px">
        <div>
          <el-button
            v-if="activeName == 'replenish_storehouse'"
            :size="$xUISize"
            @click="createByStorehouseClick"
            type="primary"
          >
            创建统采补货单
          </el-button>
        </div>
        <template v-if="!refresAble">
          <replenish-by-store v-if="activeName == 'replenish'" :query="defaultParams" />
          <replenish-by-storehouse
            v-else-if="activeName == 'replenish_storehouse'"
            :query="defaultParams"
          />
        </template>
      </div>
    </el-card>
  </div>
</template>

<script>
import customerStoreSelect from "../../../../components/business/customerStoreSelect.vue";
import replenishByStorehouse from "./__inner_replenish_list_storehouse.vue";
import replenishByStore from "./__inner_replenish_list_store.vue";
import replenishCreatePage from "./__replenish_create.vue";

export default {
  components: {
    replenishByStore,
    replenishByStorehouse,
    customerStoreSelect,
  },
  props: {
    tabName: {
      type: String,
    },
    tabProps: {
      type: Object,
      default: () => ({}),
    },
    params: {
      type: Object,
      default: () => ({}),
    },
    query: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    defaultParams() {
      return Object.assign(
        {
          optCancel: "0",
          storeGuid: this.storeGuid,
        },
        this.queryModel
      );
    },
    pageParams() {
      return Object.assign({}, (this.$route && this.$route.params) || {}, this.params);
    },
    pageQuery() {
      return Object.assign({}, (this.$route && this.$route.query) || {}, this.query);
    },
  },
  methods: {
    refresh() {
      this.refresAble = true;
      this.$nextTick(() => {
        this.refresAble = false;
      });
    },
    clearClick() {
      this.formInline = {
        optStatus: "",
        queryValue: "",
      };
      this.queryModel = {
        optStatus: "",
        queryValue: "",
      };
    },
    queryClick() {
      this.queryModel = Object.assign({}, this.formInline);
    },
    createByStorehouseClick() {
      this.$drawer.openDrawer({
        title: "创建补货单【仓库统采】",
        refresh: this.refresh,
        component: replenishCreatePage,
        params: {
          storeGuid: this.storeGuid,
        },
      });
    },
    onActiveClick(mode) {
      this.activeName = mode;
    },
  },
  watch: {
    storeGuid() {
      this.commitState({ curStoreGuid: this.storeGuid });
      this.onActiveClick("replenish_storehouse");
    },
  },
  data() {
    return {
      storeGuid: "",
      activeName: "replenish_storehouse",
      refresAble: false,
      queryModel: {
        optStatus: "",
        queryValue: "",
      },
      formInline: {
        optStatus: "",
        queryValue: "",
      },
    };
  },
  mounted() {
    this.storeGuid = this.readState("curStoreGuid", "");
  },
};
</script>
